import type { Img } from '../../types/props.js'

export type GiftBoxDataType = {
  img: Img
  mobileImg: Img
  title: string
}

export type GiftBoxData = {
  list: GiftBoxDataType[]
}

export type GiftBoxType = {
  data: GiftBoxData
  className?: string
}
